import PasswordResetForm from "../../components/password-reset-page/PasswordResetForm";

export const PASSWORD_RESET_PAGE_PATH = "/password-reset";

interface PasswordResetPageProps {}

const PasswordResetPage: React.FC<PasswordResetPageProps> = (_) => {
  return <PasswordResetForm />;
};

export default PasswordResetPage;
